<script setup lang="ts">
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
    destination?: boolean;
    time?: string;
    hideLocation?: boolean;
    durationDays?: number;
    location?: string;
    destinationHasWarning?: boolean;
    leftSided?: boolean;
}
defineProps<IProps>();
</script>

<template>
    <div
        class="time"
        :class="{
            'left-sided': leftSided,
            'with-warning': destinationHasWarning,
        }"
    >
        <div class="time-container">
            <mr-typography
                v-if="durationDays"
                size="x-small"
                color="var(--cool-gray-500)"
                class="days"
            >
                روز بعد &lrm;{{ durationDays === 1 ? '' : durationDays }}
            </mr-typography>
            <mr-typography
                :size="{ mobile: 'display4', desktop: 'display3' }"
                weight="700"
                color="var(--gray-900)"
            >
                {{ time }}
            </mr-typography>
        </div>
        <mr-icon
            v-if="destinationHasWarning"
            :icon="faCircleInfo"
            color="var(--cool-gray-600)"
            size="x-small"
        />
    </div>
</template>

<style lang="scss" scoped>
.time {
    position: relative;
    display: flex;
    align-items: center;
    text-align: right;
    white-space: nowrap;
    width: fit-content;
    &.left-sided {
        direction: ltr !important;
    }
    @include desktop-only {
        height: fit-content;
    }
    .warning {
        @include tg-xs();
    }
    .time-container {
        display: flex;
        gap: 2px;
        align-items: center;
        position: relative;
        height: 24px;
        line-height: 24px !important;
        .days {
            position: absolute;
            bottom: 23px;
            left: 50%;
            transform: translate(-50%, 0);
            @include desktop-only {
                bottom: 30px;
            }
        }
        @include desktop-only {
            height: 26px;
        }
    }
}
</style>
